import { EmblaOptionsType } from "embla-carousel";
import { useEffect, useState } from "react";
import MediaCarousel from "../../components/MediathequeSwiper/MediaCarousel";
import img from "../../images/installation_paysage.jpg";
import "../../style/carouselPerView.css";
import { getAllVideos } from "../../API/Mediatheque/Videos/videosService";
const MediathequeVideo = () => {
  const OPTIONS: EmblaOptionsType = {};

  const [videos, setVideos] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllVideos();
    setVideos(response?.videos);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const SLIDES_TO_DISPLAY = videos.slice(0, 4);
  return (
    <div className=" mb-52">
      <div className="">
        <section
          className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
            {"Médiathèque  "}
          </h1>

          <div className="flex justify-center mt-3">
            <p className="w-full text-white ">
              {"Toutes nos documentations à votre disposition"}
            </p>
          </div>
        </section>
      </div>

      <div className="pb-10 bg-bg_aquavesc">
        <h1 className="p-5 mt-20 text-4xl font-bold text-center text-black uppercase">
          VIDEOS
        </h1>

        <div className="">
          <MediaCarousel slides={SLIDES_TO_DISPLAY} options={OPTIONS} />
        </div>
      </div>
    </div>
  );
};

export default MediathequeVideo;
